import 'css-chunksrc/client/scenes/projectGroupCreation/groupCreationForm/resourcesList/addMember/styles.scss';export default {
  "icon": "_icon_pbw2j_1",
  "list": "_list_pbw2j_7"
};